<template>
  <div class="info">

    <div class="affiliate-block info-meta">
      <div v-if="affiliateHeaderLeft" v-html="affiliateHeaderLeft"></div>
    </div>

    <div class="info__image-wrapper" v-if="urls.image">
      <img class="image img-fluid" alt="image" :src="urls.image"/>
    </div>
    <div class="info__meta">
      <div class="affiliate-block affiliate-block-top info-meta">
        <div v-if="affiliateHeaderLeft" v-html="affiliateHeaderLeft"></div>
      </div>

      <h3 class="address-name">{{ campground.name }}</h3>
      <section class="section d-none d-lg-block">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="info__label">{{ $t('generic.labels.address') }}</div>
          </div>
          <div class="col-12 col-md-8">
            <ul class="address-list">
              <li v-if="campground.street1">{{ campground.street1 }}</li>
              <li v-if="campground.street2">{{ campground.street2 }}</li>
              <li v-if="campground.city">{{ campground.zip_code }} {{ campground.city }}</li>
              <li v-if="campground.country">{{ getCountryByCode(campground.country) }}</li>

              <h4
                v-if="attributes && attributes.length > 0"
                class="d-none d-lg-block"
              >
                {{ $t('generic.labels.attributes') }}
                <button
                  class="info-icon"
                  @click.prevent.stop="$modal.show(campground.name)"
                >
                  <iconInfoBlack/>
                </button>
              </h4>

              <modal
                :name="campground.name"
                height="auto"
                adaptive
                scrollable
              >
                <div class="attribute-modal">
                  <button
                    class="attribute-modal__close"
                    @click="$modal.hide(campground.name)"
                  >
                    <icon-close-dark/>
                  </button>

                  <h3 class="meta__headline">
                    {{ campground.name }}
                  </h3>

                  <div class="row">
                    <template v-for="category in attributes">
                      <div
                        class="col-12 col-md-6"
                        :key="category.name"
                      >
                        <h4>{{ category.name }}</h4>
                        <ul class="attribute-list">
                          <li
                            v-for="attribute in category.attributes"
                            :key="attribute.name"
                          >
                            <icon-checkmark-white
                              v-if="attribute.positive_flag"
                              class="attribute-checkmark"
                            />
                            <icon-cross-white
                              v-else
                              class="attribute-cross"
                            />
                            {{ attribute.name }}
                          </li>
                        </ul>
                      </div>
                    </template>
                  </div>
                </div>
              </modal>
            </ul>
          </div>
        </div>
      </section>
      <section class="section d-none d-lg-block" v-if="dates.length > 0">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="info__label">{{ $t('generic.labels.period') }}</div>
          </div>
          <div class="col-12 col-md-8">
            <div class="value" :class="{ 'value--no-padding' : isCompleted }">
              {{ getFormattedDate(dates[0]) }} -
            </div>
            <div class="value" :class="{ 'value--no-padding' : isCompleted }">
              {{ getFormattedDate(dates[1]) }}
            </div>
            <div class="nights" v-if="dates.length === 2">({{ numNights }}
              {{ $tc('generic.date.nights', numNights) }})
            </div>
          </div>
        </div>
        <button class="info__edit" v-if="!isCompleted && !isPaymentPage"
                @click="goToStep(1, { number: 1, key: 'displaySelection', value: 'dates' })">
          <iconEditGrey class="icon"></iconEditGrey>
        </button>
      </section>

      <section class="section d-none d-lg-block" v-if="selectedCampsite"
               style="max-height: 5rem; overflow: hidden">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="info__label">{{ $t('progress.step2') }}</div>
          </div>
          <div class="col-12 col-md-8">
            <div class="wrapper">
              <span class="value"
                    :class="{ 'value--no-padding' : isCompleted }">{{
                  selectedCampsite.name
                }}</span>
              <span v-if="false" style="font-size: small"
                    v-html="selectedCampsite.description"></span>
            </div>
          </div>
          <button class="info__edit" v-if="!isCompleted && !isPaymentPage"
                  @click="goToStep(2, { number: 2, key: 'displaySelection', value: 'campsites' })">
            <iconEditGrey class="icon"></iconEditGrey>
          </button>
        </div>
      </section>

      <section class="section d-none d-lg-block" v-if="guests && guests.length > 0">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="info__label">{{ $t('generic.labels.guests') }}</div>
          </div>
          <div class="col-12 col-md-8">
            <div class="wrapper" v-for="(guest, index) of getGuestData" :key="index">
              <span class="value" :class="{ 'value--no-padding' : isCompleted }">{{ guest.amount }}x {{
                  guest.name
                }}</span>
            </div>
          </div>
        </div>

        <button class="info__edit" v-if="!isCompleted && !isPaymentPage"
                @click="goToStep(1, { number: 1, key: 'displaySelection', value: 'persons' })">
          <iconEditGrey class="icon"></iconEditGrey>
        </button>
      </section>
    </div>
<!--    TODO: leave this on booking page but then remove buttons when active?-->
    <div class="info__booking" v-if="!isCompleted && !isPaymentPage">
      <CiButton
        class="button--tertiary-outline info__booking__button"
        :class="{ 'button--primary-outline': isCompleted }" @click="toggleBookingDetails">
        <span>{{ $t('generic.buttons.showDetails') }}</span>
        <iconArrowBlack class="icon icon--animated"></iconArrowBlack>
      </CiButton>
    </div>
    <div class="info__sum">
      <slot name="sum"></slot>
    </div>
    <div
      v-if="showNewBookingButton"
      class="info__sum"
    >
      <CiButton
        class="button--primary"
        @click="goToStep(1, { number: 1, key: 'displaySelection', value: 'persons' })"
      >
        {{ $t('pages.checkoutStepFive.startNewBooking') }}
      </CiButton>
    </div>
  </div>
</template>

<script>
import {CiButton} from '@/components'
import bookingDataMixin from '@/mixins/bookingDataMixin'

import iconCheckmarkWhite from '@/assets/icons/checkmark-white.svg'
import iconCrossWhite from '@/assets/icons/cross-white.svg'
import iconArrowBlack from '@/assets/icons/arrow-black.svg'
import iconClose from '@/assets/icons/close-dark.svg'
import iconEditGrey from '@/assets/icons/edit-grey.svg'
import iconInfoBlack from '@/assets/icons/info-black.svg'
import iconInfoWhite from '@/assets/icons/info-white.svg'
import iconCloseDark from '@/assets/icons/close-dark.svg'
import {mapGetters} from 'vuex'

export default {
  name: 'CiCampgroundInfo',
  mixins: [bookingDataMixin],
  components: {
    CiButton,
    iconArrowBlack,
    iconClose,
    iconEditGrey,
    iconInfoBlack,
    iconInfoWhite,
    iconCloseDark,
    iconCheckmarkWhite,
    iconCrossWhite,
  },
  props: {
    campground: {
      type: Object,
      required: true,
    },
    confirmation: {
      type: Object,
      required: false,
    },
    countries: {
      type: Array,
      required: false,
    },
    currency: {
      type: Object,
      required: true,
    },
    dates: {
      type: Array,
      required: false,
    },
    guests: {
      type: Array,
      required: false,
    },
    isCompleted: {
      type: Boolean,
      default: false,
    },
    urls: {
      type: Object,
      required: true,
    },
    setStepStatus: {
      type: Function,
      required: false,
    },
    toggleBookingDetails: {
      type: Function,
      required: false,
    },
  },
  computed: {
    isPaymentPage() {
      return this.$route.name === 'StripePayment';
    },
    ...mapGetters('campground', {
      attributes: 'attributes'
    }),
    ...mapGetters('booking', {
      selectedCampsite: 'selectedCampsite',
    }),

    showNewBookingButton() {
      return this.$route.name === 'Confirmation' || this.$route.name === 'PartialConfirmation'
    },
    affiliateJson() {
      const affiliateData = this.$store.getters['campground/affiliateHtml'];
      return affiliateData && typeof affiliateData === 'object' ? affiliateData : {};
    },
    affiliateHeaderLeft() {
      const affiliateHtml = this.affiliateJson;
      return affiliateHtml && affiliateHtml.header_left ? affiliateHtml.header_left : null;
    },
    getGuestData() {
      return this.isCompleted
        ? this.guests
        : this.guests.map(guest => {
          const p = this.campground.persons.find(p => p.id === guest.id)
          return {...p, ...guest}
        })
    },
  },
  methods: {
    goToStep(step, stepStatus) {
      if (this.setStepStatus) {
        this.setStepStatus({
          number: stepStatus.number,
          key: stepStatus.key,
          value: stepStatus.value,
        })
      }

      this.$router.push({
        name: 'Step',
        params: {...this.$route.params, step: step},
      })
    },
  },
}

</script>

<style lang="scss" scoped>
.info {
  @include media-breakpoint-up(lg) {
    display: block;
    min-height: 100%;
    background: white;
    overflow: hidden;
    padding: 0 20px;
  }

  @include media-breakpoint-up(xl) {
    padding: 0 50px;
  }

  &__booking,
  &__sum {
    display: none;

    @include media-breakpoint-up(lg) {
      display: block;
    }
  }
}

.affiliate__image-wrapper {
  max-width: 50px
}

.info__image-wrapper {
  position: relative;
  max-width: 175px;
  border-radius: 50%;
  border: 5px solid white;
  box-shadow: 0 0 0 6px rgba(0, 0, 0, 0.01), 0 20px 48px 0 rgba(53, 53, 53, 0.17);
  margin: 5rem auto 0;
  overflow: hidden;
  z-index: 1;

  @include media-breakpoint-up(lg) {
    margin: 2.5rem auto;
  }

  img {
    width: 100%;
  }
}

.info__meta {
  position: relative;
  margin-top: 60px;

  @include media-breakpoint-down(md) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    margin-top: 0;
    padding: 1rem;
    background-color: $white;
    border-bottom: 1px solid var(--primary-color);
    z-index: 99;
  }

  .address-name {
    margin-bottom: 30px;
    text-align: center;

    @include media-breakpoint-down(lg) {
      margin-bottom: 0;
    }
  }

  .info__label {
    @include font('gotham_mediumregular');
    @include font-format(0.875rem, 1.25rem);
  }

  .address-list {
    @include font-format(0.875rem, 1.25rem);

    list-style: none;
    margin: 0;
    padding: 0;
  }

  .section {
    position: relative;
    margin: 0 0 25px;

    &:last-child {
      margin: 0;
    }

    .info__edit {
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
      border: none;
      background-color: transparent;

      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }

  .nights {
    color: #9f9f9f;
  }

  .value {
    display: block;
    padding-right: 45px;

    &.value--no-padding {
      padding: 0;
    }
  }
}

.info__image-wrapper + .info__meta {
  margin: 0;
}

.info__booking {
  margin: 40px 0;

  .icon {
    transform: translate3d(0, -50%, 0) rotate(180deg);
  }

  .no-touch &:hover span + .icon {
    transform: rotate(180deg) translate3d(-5px, 50%, 0);
  }

  .info__booking__button {
    margin: 0 auto;
    width: 100%;
  }
}

.info__sum {
  margin-top: 40px;

  // this code is making the display break?
  //@include media-breakpoint-up(lg) {
  //  margin: auto;
  //}

  .sum {
    //padding-left: 35px;
  }
}

.affiliate-block {
  margin-top: 0;
  text-align: center;
}

.affiliate-block-top {
  @include media-breakpoint-up(lg) {
    display: none;
  }
}

</style>
